import React, {Component} from 'react';
import styled from "styled-components";

import {MAIN_APP} from '../MidiPlay.jsx';

import InterfaceIconDropdown from '../interface/InterfaceIconDropdown.jsx';
import ModuleTransport from '../module/ModuleTransport.jsx';

import MenuFile from '../menu/MenuFile.jsx';
import MenuOpen from '../menu/MenuOpen.jsx';
import MenuSave from '../menu/MenuSave.jsx';
import MenuSettings from '../menu/MenuSettings.jsx';
import MenuSearch from '../menu/MenuSearch.jsx';

import Colors from '../resource/ResourceColors.jsx';
import '../app_styles.css';

const HEADER_HEIGHT = "2.5rem"

const Background = styled.div`
    font-family: Arial;
    user-select: none;
    width: 100%;
    height: ${HEADER_HEIGHT};
    padding-left: 1rem;
    padding-top: 0.2rem;
    background: ${Colors.right_diagonal_gradient(80, 40)};
`;

const GradientBorder = styled.div`
    width: 100%;
    height: 0.25rem;
    background: ${Colors.right_diagonal_gradient(80, 20)};
    filter: ${Colors.medium_shadow(70)};
`;

const TitleText = styled.div`
    font-size: 1.9em;
    color: ${Colors.primary(95)};
    letter-spacing: 1rem;
    float: left;
    margin-left: 2.5rem;
    text-shadow: ${Colors.tight_text_shadow(80)};
`;

const Info = styled.div`
    font-size: 0.8rem;
    font-family: Courier;
    font-style: italic;
    font-weight: bold;
    margin: 0.5rem;
    text-shadow: ${Colors.tight_text_shadow(80)};
`;

const Error = styled(Info)`
    color: #ffdddd;
    font-size: 1.25rem
`;

export class AppHeader extends Component {

    state = {
        open_ref: React.createRef()
    };

    render() {
        const textError = !MAIN_APP ? '' :
            MAIN_APP.state.error_text != null ? <Error>{MAIN_APP.state.error_text}</Error> : '';

        const open_menu = this.state.open_ref ? this.state.open_ref.current : null;
        return <div>
            <MenuOpen ref={this.state.open_ref}/>
            <Background>
                <InterfaceIconDropdown
                    icon_name={'file'}
                    icon_size={"1.5rem"}
                    icon_color={Colors.primary(40)}
                    icon_bgcolor={Colors.primary(95)}
                    dropdown_options={MenuFile.options}
                    tooltip={'new file'}/>
                <InterfaceIconDropdown
                    icon_name={'folder-open'}
                    icon_size={"1.8rem"}
                    icon_color={Colors.primary(40)}
                    icon_bgcolor={Colors.hue(33, 80)}
                    dropdown_options={open_menu ? open_menu.get_options () : []}
                    dropdown_handler={(item) => open_menu.listen_dropdown (item)}
                    tooltip={'open file'}
                    icon_style={{marginTop: "0.4rem"}}/>
                <InterfaceIconDropdown
                    icon_name={'save'}
                    icon_size={"1.7rem"}
                    icon_color={Colors.primary(40)}
                    icon_bgcolor={'lightcoral'}
                    dropdown_options={MenuSave.options}
                    tooltip={'save file'}
                    icon_style={{marginTop: "0.45rem"}}/>
                <InterfaceIconDropdown
                    icon_name={'cog'}
                    icon_size={"1.4rem"}
                    icon_color={Colors.primary(95)}
                    dropdown_options={MenuSettings.options}
                    tooltip={'settings'}/>
                <InterfaceIconDropdown
                    icon_name={'search'}
                    icon_size={"1.4rem"}
                    icon_color={Colors.primary(95)}
                    dropdown_options={MenuSearch.options}
                    tooltip={'search'}/>

                <TitleText>Tone Gallery</TitleText>

                {textError}
                <ModuleTransport/>

            </Background>
            <GradientBorder/>
        </div>
    }
}

export default AppHeader;
